// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Jzon from "rescript-jzon/lib/es6/src/Jzon.res.js";
import * as React from "react";
import * as Future from "rescript-future/lib/es6/src/Future.res.js";
import * as LumiReact from "./LumiReact.res.js";
import * as LumiResult from "./LumiResult.res.js";
import * as FuturePromise from "rescript-future/lib/es6/src/FuturePromise.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as Stdlib_Result from "@rescript/runtime/lib/es6/Stdlib_Result.js";
import * as Primitive_option from "@rescript/runtime/lib/es6/Primitive_option.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as JsCookieJs from "lumi-rescript/src/js-cookie.js";

function toShortString(err) {
  let shorten = str => {
    let parts = str.split(" ");
    if (parts.length <= 3) {
      return str;
    } else {
      return parts[0] + " (...) " + parts[parts.length - 1 | 0];
    }
  };
  if (err.TAG === "FailureResponse") {
    return "HTTP " + err.status.toString() + " " + err.statusText + Stdlib_Option.mapOr(err.body, "", body => ": " + shorten(body));
  } else {
    return `Invalid response: ` + shorten(err._0);
  }
}

function toString(err) {
  if (err.TAG === "FailureResponse") {
    return "HTTP " + err.status.toString() + " " + err.statusText + Stdlib_Option.mapOr(err.body, "", body => ": " + body);
  } else {
    return `Invalid response: ` + err._0;
  }
}

function toLumiRequestError(err) {
  if (err.TAG === "FailureResponse") {
    return {
      TAG: "ServerError",
      status: err.status,
      statusText: err.statusText,
      response: err.body
    };
  } else {
    return {
      TAG: "InvalidResponse",
      _0: err._0
    };
  }
}

function LumiFetch$Error$Notification(props) {
  let __classList = props.classList;
  let error = props.error;
  let classList = __classList !== undefined ? __classList : [[
        "is-danger",
        true
      ]];
  let className = LumiReact.classList([[
      "notification",
      true
    ]].concat(classList));
  let tmp;
  tmp = error.TAG === "FailureResponse" ? JsxRuntime.jsxs(JsxRuntime.Fragment, {
      children: [
        JsxRuntime.jsx("span", {
          children: `HTTP ` + error.status.toString() + ` ` + error.statusText
        }),
        LumiReact.renderOption(undefined, error.body, body => JsxRuntime.jsx("pre", {
          children: body,
          style: {
            whiteSpace: "pre-wrap"
          }
        }))
      ]
    }) : JsxRuntime.jsxs(JsxRuntime.Fragment, {
      children: [
        JsxRuntime.jsx("span", {
          children: "Invalid response"
        }),
        JsxRuntime.jsx("pre", {
          children: error._0,
          style: {
            whiteSpace: "pre-wrap"
          }
        })
      ]
    });
  return JsxRuntime.jsx("div", {
    children: tmp,
    className: className,
    onClick: props.onClick
  });
}

let Notification = {
  make: LumiFetch$Error$Notification
};

let $$Error = {
  toShortString: toShortString,
  toString: toString,
  toLumiRequestError: toLumiRequestError,
  Notification: Notification
};

async function responseOk(response) {
  if (response.ok) {
    return {
      TAG: "Ok",
      _0: response
    };
  }
  let bodyString = await response.text();
  let tmp = bodyString === "" ? undefined : bodyString;
  return {
    TAG: "Error",
    _0: {
      TAG: "FailureResponse",
      status: response.status,
      statusText: response.statusText,
      body: tmp
    }
  };
}

async function decodeBlob(response) {
  let okResponse = await responseOk(response);
  let blobResult = await LumiResult.mapP(okResponse, prim => prim.blob());
  return Stdlib_Result.map(blobResult, prim => prim);
}

async function decodeNull(response) {
  let okResponse = await responseOk(response);
  let textResult = await LumiResult.mapP(okResponse, prim => prim.text());
  return Stdlib_Result.flatMap(textResult, text => {
    if (text === "") {
      return {
        TAG: "Ok",
        _0: undefined
      };
    } else {
      return {
        TAG: "Error",
        _0: {
          TAG: "InvalidResponse",
          _0: `Response body should be empty but is: ` + text
        }
      };
    }
  });
}

async function decodeJson(response, codec) {
  let okResponse = await responseOk(response);
  let jsonResult = await LumiResult.mapP(okResponse, prim => prim.json());
  return Stdlib_Result.flatMap(jsonResult, json => Stdlib_Result.mapError(Jzon.decodeWith(json, codec), err => ({
    TAG: "InvalidResponse",
    _0: Jzon.DecodingError.toString(err)
  })));
}

let Response = {
  responseOk: responseOk,
  decodeBlob: decodeBlob,
  decodeNull: decodeNull,
  decodeJson: decodeJson
};

let acceptJpeg = [
  "Accept",
  "image/jpeg"
];

let acceptJson = [
  "Accept",
  "application/json;charset=utf-8"
];

let contentJson = [
  "Content-Type",
  "application/json;charset=utf-8"
];

let contentSvg = [
  "Content-Type",
  "image/svg+xml"
];

let lumiAuth_1 = Stdlib_Option.getOr(JsCookieJs.get("XSRF-TOKEN"), "");

let lumiAuth = [
  "X-XSRF-TOKEN",
  lumiAuth_1
];

function decodeJson$1(headers, headerKey, codec) {
  let header = headers.get(headerKey);
  return Stdlib_Result.mapError((header == null) ? ({
      TAG: "Error",
      _0: `Missing ` + headerKey + ` header`
    }) : Stdlib_Result.mapError(Jzon.decodeStringWith(header, codec), x => Jzon.DecodingError.toString(x)), x => ({
    TAG: "InvalidResponse",
    _0: x
  }));
}

function decodeString(headers, headerKey, decode) {
  let header = headers.get(headerKey);
  return Stdlib_Result.mapError((header == null) ? ({
      TAG: "Error",
      _0: `Missing ` + headerKey + ` header`
    }) : decode(header), x => ({
    TAG: "InvalidResponse",
    _0: x
  }));
}

let Header = {
  acceptJpeg: acceptJpeg,
  acceptJson: acceptJson,
  contentJson: contentJson,
  contentSvg: contentSvg,
  lumiAuth: lumiAuth,
  decodeJson: decodeJson$1,
  decodeString: decodeString
};

function makeWithDecode(baseUrl, paramsOpt, init, decode) {
  let params = paramsOpt !== undefined ? paramsOpt : [];
  return {
    baseUrl: baseUrl,
    params: params,
    init: init,
    decode: decode
  };
}

function make(baseUrl, paramsOpt, init) {
  let params = paramsOpt !== undefined ? paramsOpt : [];
  return makeWithDecode(baseUrl, params, init, decodeNull);
}

function map(request, f) {
  return {
    baseUrl: request.baseUrl,
    params: request.params,
    init: request.init,
    decode: resp => request.decode(resp).then(result => Stdlib_Result.map(result, f))
  };
}

function url(param) {
  let params = param.params;
  let baseUrl = param.baseUrl;
  let query = new URLSearchParams(params).toString();
  if (params.length !== 0) {
    return baseUrl + `?` + query;
  } else {
    return baseUrl;
  }
}

function addHeader(request, param) {
  let headers = Stdlib_Option.getOr(request.init.headers, new Headers());
  headers.set(param[0], param[1]);
  let newrecord = {...request.init};
  return {
    baseUrl: request.baseUrl,
    params: request.params,
    init: (newrecord.headers = Primitive_option.some(headers), newrecord),
    decode: request.decode
  };
}

function makeAuth(baseUrl, paramsOpt, init) {
  let params = paramsOpt !== undefined ? paramsOpt : [];
  return addHeader(make(baseUrl, params, init), lumiAuth);
}

function accept(request, header, decode) {
  return addHeader({
    baseUrl: request.baseUrl,
    params: request.params,
    init: request.init,
    decode: decode
  }, header);
}

function acceptJson$1(request, codec) {
  return accept(request, acceptJson, json => decodeJson(json, codec));
}

function acceptJpeg$1(request) {
  return accept(request, acceptJpeg, decodeBlob);
}

function setBody(request, body) {
  let newrecord = {...request.init};
  return {
    baseUrl: request.baseUrl,
    params: request.params,
    init: (newrecord.body = Primitive_option.some(body), newrecord),
    decode: request.decode
  };
}

function content(request, content$1, header) {
  return addHeader(setBody(request, content$1), header);
}

function contentJson$1(request, body, codec) {
  return content(request, Jzon.encodeStringWith(body, codec), contentJson);
}

function contentSvg$1(request, body) {
  return content(request, body, contentSvg);
}

function toLumiRequest(request) {
  return {
    url: url(request),
    method: Stdlib_Option.mapOr(request.init.method, "GET", method => method),
    headers: Stdlib_Option.mapOr(request.init.headers, {}, prim => prim),
    body: Stdlib_Option.map(request.init.body, prim => prim),
    parseResponse: response => Future.map(Future.map(FuturePromise.fromPromise(request.decode(response)), undefined, __x => Stdlib_Result.getOrThrow(__x, undefined)), undefined, res => Stdlib_Result.mapError(res, toLumiRequestError))
  };
}

let Request = {
  makeWithDecode: makeWithDecode,
  make: make,
  map: map,
  url: url,
  addHeader: addHeader,
  makeAuth: makeAuth,
  accept: accept,
  acceptJson: acceptJson$1,
  acceptJpeg: acceptJpeg$1,
  setBody: setBody,
  content: content,
  contentJson: contentJson$1,
  contentSvg: contentSvg$1,
  toLumiRequest: toLumiRequest
};

async function fetch(originalRequest) {
  let request = addHeader(originalRequest, [
    "X-XSRF-TOKEN",
    Stdlib_Option.getOr(JsCookieJs.get("XSRF-TOKEN"), "")
  ]);
  let response = await globalThis.fetch(url(request), request.init);
  return await request.decode(response);
}

function map$1(resp, f) {
  if (typeof resp !== "object") {
    return "Loading";
  }
  if (resp.TAG === "Reloading") {
    let result = resp._0;
    if (result.TAG === "Ok") {
      return {
        TAG: "Reloading",
        _0: {
          TAG: "Ok",
          _0: f(result._0)
        }
      };
    } else {
      return {
        TAG: "Reloading",
        _0: {
          TAG: "Error",
          _0: result._0
        }
      };
    }
  }
  let result$1 = resp._0;
  if (result$1.TAG === "Ok") {
    return {
      TAG: "Fetched",
      _0: {
        TAG: "Ok",
        _0: f(result$1._0)
      }
    };
  } else {
    return {
      TAG: "Fetched",
      _0: {
        TAG: "Error",
        _0: result$1._0
      }
    };
  }
}

function flatMap(resp, f) {
  if (typeof resp !== "object") {
    return "Loading";
  }
  if (resp.TAG === "Reloading") {
    let result = resp._0;
    if (result.TAG !== "Ok") {
      return {
        TAG: "Reloading",
        _0: {
          TAG: "Error",
          _0: result._0
        }
      };
    }
    let res = f(result._0);
    if (typeof res !== "object" || res.TAG === "Reloading") {
      return res;
    } else {
      return {
        TAG: "Reloading",
        _0: res._0
      };
    }
  }
  let result$1 = resp._0;
  if (result$1.TAG === "Ok") {
    return f(result$1._0);
  } else {
    return {
      TAG: "Fetched",
      _0: {
        TAG: "Error",
        _0: result$1._0
      }
    };
  }
}

function toOption(resp) {
  if (typeof resp !== "object") {
    return;
  }
  if (resp.TAG === "Reloading") {
    let result = resp._0;
    if (result.TAG === "Ok") {
      return Primitive_option.some(result._0);
    } else {
      return;
    }
  }
  let result$1 = resp._0;
  if (result$1.TAG === "Ok") {
    return Primitive_option.some(result$1._0);
  }
}

function splitTuple(tup) {
  if (typeof tup !== "object") {
    return [
      "Loading",
      "Loading"
    ];
  }
  if (tup.TAG === "Reloading") {
    let err = tup._0;
    if (err.TAG === "Ok") {
      let match = err._0;
      return [
        {
          TAG: "Reloading",
          _0: {
            TAG: "Ok",
            _0: match[0]
          }
        },
        {
          TAG: "Reloading",
          _0: {
            TAG: "Ok",
            _0: match[1]
          }
        }
      ];
    }
    let err$1 = err._0;
    return [
      {
        TAG: "Reloading",
        _0: {
          TAG: "Error",
          _0: err$1
        }
      },
      {
        TAG: "Reloading",
        _0: {
          TAG: "Error",
          _0: err$1
        }
      }
    ];
  }
  let err$2 = tup._0;
  if (err$2.TAG === "Ok") {
    let match$1 = err$2._0;
    return [
      {
        TAG: "Fetched",
        _0: {
          TAG: "Ok",
          _0: match$1[0]
        }
      },
      {
        TAG: "Fetched",
        _0: {
          TAG: "Ok",
          _0: match$1[1]
        }
      }
    ];
  }
  let err$3 = err$2._0;
  return [
    {
      TAG: "Fetched",
      _0: {
        TAG: "Error",
        _0: err$3
      }
    },
    {
      TAG: "Fetched",
      _0: {
        TAG: "Error",
        _0: err$3
      }
    }
  ];
}

function isLoading(result) {
  if (typeof result !== "object") {
    return true;
  } else {
    return result.TAG === "Reloading";
  }
}

function sequence2(param) {
  let b = param[1];
  return flatMap(param[0], a => map$1(b, b => [
    a,
    b
  ]));
}

function sequence3(param) {
  let c = param[2];
  let b = param[1];
  return flatMap(param[0], a => map$1(sequence2([
    b,
    c
  ]), param => [
    a,
    param[0],
    param[1]
  ]));
}

function sequence4(param) {
  let d = param[3];
  let c = param[2];
  let b = param[1];
  return flatMap(param[0], a => map$1(sequence3([
    b,
    c,
    d
  ]), param => [
    a,
    param[0],
    param[1],
    param[2]
  ]));
}

function sequence5(param) {
  let e = param[4];
  let d = param[3];
  let c = param[2];
  let b = param[1];
  return flatMap(param[0], a => map$1(sequence4([
    b,
    c,
    d,
    e
  ]), param => [
    a,
    param[0],
    param[1],
    param[2],
    param[3]
  ]));
}

function sequence6(param) {
  let f = param[5];
  let e = param[4];
  let d = param[3];
  let c = param[2];
  let b = param[1];
  return flatMap(param[0], a => map$1(sequence5([
    b,
    c,
    d,
    e,
    f
  ]), param => [
    a,
    param[0],
    param[1],
    param[2],
    param[3],
    param[4]
  ]));
}

function sequence7(param) {
  let h = param[6];
  let f = param[5];
  let e = param[4];
  let d = param[3];
  let c = param[2];
  let b = param[1];
  return flatMap(param[0], a => map$1(sequence6([
    b,
    c,
    d,
    e,
    f,
    h
  ]), param => [
    a,
    param[0],
    param[1],
    param[2],
    param[3],
    param[4],
    param[5]
  ]));
}

let Result = {
  map: map$1,
  flatMap: flatMap,
  toOption: toOption,
  splitTuple: splitTuple,
  isLoading: isLoading,
  sequence2: sequence2,
  sequence3: sequence3,
  sequence4: sequence4,
  sequence5: sequence5,
  sequence6: sequence6,
  sequence7: sequence7
};

function useFetch(f, deps, onFetchOpt) {
  let onFetch = onFetchOpt !== undefined ? onFetchOpt : async (param, param$1) => {};
  let match = React.useState(() => {});
  let setData = match[1];
  let fetch = React.useCallback(async key => {
    setData(prev => {
      if (typeof prev === "object") {
        return {
          TAG: "Reloading",
          _0: prev._0
        };
      } else {
        return "Loading";
      }
    });
    let response = await f(key);
    if (response.TAG === "Ok") {
      let response$1 = response._0;
      setData(param => ({
        TAG: "Fetched",
        _0: {
          TAG: "Ok",
          _0: response$1
        }
      }));
      return await onFetch(key, response$1);
    }
    let err = response._0;
    setData(param => ({
      TAG: "Fetched",
      _0: {
        TAG: "Error",
        _0: err
      }
    }));
    console.error("Error fetching data", err, key);
  }, deps);
  return {
    data: match[0],
    fetch: fetch
  };
}

let Manual = {
  useFetch: useFetch
};

function useFetch$1(f, deps) {
  let match = React.useState(() => "Loading");
  let setData = match[1];
  let data = match[0];
  let fetch = React.useCallback(async () => {
    setData(prev => {
      if (typeof prev !== "object") {
        return "Loading";
      } else {
        return {
          TAG: "Reloading",
          _0: prev._0
        };
      }
    });
    let x = await f();
    if (x.TAG === "Ok") {
      let x$1 = x._0;
      return setData(param => ({
        TAG: "Fetched",
        _0: {
          TAG: "Ok",
          _0: x$1
        }
      }));
    }
    let err = x._0;
    console.error("Error fetching data", err);
    return setData(param => ({
      TAG: "Fetched",
      _0: {
        TAG: "Error",
        _0: err
      }
    }));
  }, deps);
  React.useEffect(() => {
    fetch();
  }, [fetch]);
  return React.useMemo(() => ({
    data: data,
    fetch: fetch
  }), [
    data,
    fetch
  ]);
}

function useFetch0(f) {
  return useFetch$1(f, []);
}

function useAutoReloadingFetch(f, deps, errorPredicateOpt, reloadDelayMsOpt) {
  let errorPredicate = errorPredicateOpt !== undefined ? errorPredicateOpt : param => true;
  let reloadDelayMs = reloadDelayMsOpt !== undefined ? reloadDelayMsOpt : 5000;
  let match = useFetch$1(f, deps);
  let fetch = match.fetch;
  let data = match.data;
  React.useEffect(() => {
    let timeoutId = setTimeout(() => {
      if (typeof data !== "object") {
        return;
      }
      if (data.TAG === "Reloading") {
        return;
      }
      let err = data._0;
      if (err.TAG === "Ok" || !errorPredicate(err._0)) {
        return;
      } else {
        fetch();
        return;
      }
    }, reloadDelayMs);
    return () => {
      clearTimeout(timeoutId);
    };
  }, [data]);
  return {
    data: data,
    fetch: fetch
  };
}

function useMap(param, f, deps) {
  let fetch = param.fetch;
  let data = param.data;
  let update = React.useCallback(x => f(x), deps);
  return React.useMemo(() => ({
    data: update(data),
    fetch: fetch
  }), [
    data,
    fetch,
    update
  ]);
}

function useMapResult(res, f, deps) {
  return useMap(res, x => map$1(x, f), deps);
}

function toServer(req) {
  return {
    baseUrl: "https://stallingsnet.nl" + req.baseUrl,
    params: req.params,
    init: req.init,
    decode: req.decode
  };
}

export {
  $$Error,
  Response,
  Header,
  Request,
  fetch,
  Result,
  Manual,
  useFetch$1 as useFetch,
  useFetch0,
  useAutoReloadingFetch,
  useMap,
  useMapResult,
  toServer,
}
/* lumiAuth Not a pure module */
